import { useAppSelector } from '@/configuration/setup/hooks';
import {
  selectDocumentViewerPageRequestId,
  selectDocumentViewerSource,
  selectDocumentViewerSourceElementId,
} from '@/store/documentViewer/documentViewerSlice';

import DocumentViewerPanel from './DocumentViewerPanel';

const DocumentViewer = () => {
  const source = useAppSelector(selectDocumentViewerSource);
  const pageRequestId = useAppSelector(selectDocumentViewerPageRequestId);
  const sourceElementId = useAppSelector(selectDocumentViewerSourceElementId);

  if (!source) return null;

  return <DocumentViewerPanel source={source} pageRequestId={pageRequestId} sourceElementId={sourceElementId} />;
};

export default DocumentViewer;
